/* eslint-disable */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from 'antd';

import PropTypes from 'prop-types';

import css from './Compilations.module.scss';

export default function CompilationsEmptyPlaceholder(props) {
  const { t } = useTranslation('compilations');

  if (props.isFavorite && !props.isSearching) {
    return (
      <div className={css.notFound}>
        {t('favorite')}
        <Link to='/compilations'>
          <Button size='large' type='primary' onClick={() => null}>
            {t('goTo')}
          </Button>
        </Link>
      </div>
    );
  } else if (props.isSearching) {
    return (
      <div data-qa='userCompilationsNotFoundBlock' className={css.notFound}>
        {t('tryToChangeFilters')}
      </div>
    );
  } else {
    return (
      <div data-qa='userCompilationsNotFoundBlock' className={css.notFound}>
        {t('experts')}
      </div>
    );
  }
}

CompilationsEmptyPlaceholder.propTypes = {
  isFavorite: PropTypes.bool,
  isSearching: PropTypes.bool,
};
